import React, { useState } from "react"
import ReactApexChart from "react-apexcharts"

const TotalVehicleChart = ({ vehicleData }) => {
  const [options] = useState({
    chart: {
      type: "pie",
      fontFamily: `'Poppins', sans-serif`,
      foreColor: "#000000",
      width: "100%",
      height: 430,
    },
    plotOptions: {
      pie: {
        expandOnClick: true,
        dataLabels: {
          minAngleToShowLabel: 0,
        },
      },
    },
    labels: ["2 Wheeler", "3 Wheeler", "4 Wheeler"],
    fill: {
      colors: ["#04BFDA", "#9B88ED", "#FFA84A"],
    },
    stroke: {
      width: 0,
    },
    title: {
      text: "Total Vehicle",
      offsetX: -10,
      style: {
        fontSize: "18px",
        fontWeight: "500",
        color: "#263238",
      },
    },
    tooltip: {
      enabled: true,
      theme: "light",
      style: {
        fontSize: "14px",
        fontFamily: "Poppins, sans-serif",
      },
      fillSeriesColor: false,
      custom: function ({ series, seriesIndex, w }) {
        const labels = w.globals.labels
        const values = series[seriesIndex]
        const bgColors = ["#04BFDA", "#9B88ED", "#FFA84A"]
        const textColors = ["#ffffff", "#ffffff", "#000000"]

        return `
          <div style="
            background-color: ${bgColors[seriesIndex]};
            color: ${textColors[seriesIndex]};
            padding: 8px 12px;
            border-radius: 8px;
            border: 0;
            box-shadow: none;
            font-weight: 500;
          ">
            ${labels[seriesIndex]}: ${values}
          </div>
        `
      },
    },
    legend: {
      show: true,
      fontWeight: "500",
      position: "bottom",
      markers: {
        size: 0,
      },
      itemMargin: {
        horizontal: 10,
      },
      formatter: function (seriesName, opts) {
        const icons = [
          '<i class="icon_main two_wheels" style="background-color: #04BFDA;"></i>',
          '<i class="icon_main three_wheels" style="background-color: #9B88ED;"></i>',
          '<i class="icon_main four_wheels" style="background-color: #FFA84A;"></i>',
        ]
        return `${icons[opts.seriesIndex]} ${seriesName}`
      },
      onItemHover: {
        highlightDataSeries: false,
      },
      onItemClick: {
        toggleDataSeries: true,
      },
    },
  })

  const series = [
    Number(vehicleData?.twoWheelerCount) || 0,
    Number(vehicleData?.threeWheelerCount) || 0,
    Number(vehicleData?.fourWheelerCount) || 0,
  ]
  const hasVehicles = series.some((count) => count > 0)

  return (
    <>
      {hasVehicles ? (
        <ReactApexChart
          className="piechart"
          options={options}
          series={series}
          type="pie"
          height={430}
        />
      ) : (
        <div className="d-flex flex-column h-100">
          <h3 className="card_title mb-0">Total Vehicle</h3>
          <div className="d-flex flex-grow-1 flex-column align-items-center justify-content-center py-5 text-center text-body-secondary">
            <i className="icon_main two_wheels mb-2" aria-hidden="true" />
            <p className="mb-1 fw-medium">No fleet vehicles yet</p>
            <small>Vehicle totals will appear here once vehicles are added.</small>
          </div>
        </div>
      )}
    </>
  )
}

export default TotalVehicleChart
